export default "__VITE_ASSET__Cti2oo6O__"